import React, { useEffect, useRef } from "react";

import "./about.scss";

import { useWindowDimensions } from "../../hooks";
import PRISMA from "../../assets/images/PRISMA.jpg";
import PRISPEK from "../../assets/images/PRISPEK.png";
import SPEKTRA from "../../assets/images/SPEKTRA.png";
import { Bookings } from "../../config";
import { Navbar, AboutCard, Footer, Team } from "..";
import Stack from "@mui/material/Stack";

export const AboutPage: React.FC = React.memo(() => {
  const { width } = useWindowDimensions();
  const topRef = useRef<HTMLElement>(null);
  const prispekRef = useRef<HTMLElement>(null);
  const spektraRef = useRef<HTMLElement>(null);
  const prismaRef = useRef<HTMLElement>(null);

  useEffect(() => {
    switch (window.location.hash) {
      case "#prispek":
        prispekRef.current?.scrollIntoView();
        break;
      case "#spektra":
        spektraRef.current?.scrollIntoView();
        break;
      case "#prisma":
        prismaRef.current?.scrollIntoView();
        break;
      default:
        topRef.current?.scrollIntoView();
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.hash]);

  return (
    <section ref={topRef}>
      <Navbar about={true} />
      <div className="section" id="team">
        <Team />
        <Stack alignItems="center" width="100%">
          <section style={{ paddingTop: "4rem" }} ref={prispekRef}>
            <AboutCard
              width={width}
              logo={PRISPEK}
              title="Prispek"
              about={[
                {
                  key: 0,
                  paragraph:
                    "Christo Viljoen & Gerhard Labuschagne started a partnership in 1996 to address the needs of small to medium size businesses regarding sound financial advice and accounting services. Providing a one-stop point of professional advice and giving valuable back office accounting support offered clients the unique opportunity to focus on their primary areas of expertise whilst knowing that the financial planning and implementation ran smoothly behind the scenes. This advice and service was to be given with INTEGRITY at all times.",
                },
                {
                  key: 1,
                  paragraph:
                    "Following the early successes achieved by Spektra Financial Services and Prisma Accountants, Prispek Consulting was formed in 1999 to act as a single point of contact for clients wishing to be part of this solution and to provide proper succession planning for the members.  Clients make initial contact with Prispek Consulting, from where they are referred to either Spektra Financial Services or Prisma Accountants for the specialised services they need. Close relations created with other companies with other specialised services has led to unique, unbiased advice and services delivered to all clients, strengthening the desire to create wealth with integrity for their clients.",
                },
                {
                  key: 2,
                  paragraph:
                    "Prispek Consulting has grown to a thriving business assisting clients with their wills and executorship with deceased estates, providing clients the peace of mind that their finances and businesses are taken care of right from the start until even after their deaths and proper distribution of their estates.",
                },
              ]}
            />
          </section>
          <section style={{ paddingTop: "4rem" }} ref={spektraRef}>
            <AboutCard
              width={width}
              logo={SPEKTRA}
              title="Spektra"
              contactLink={Bookings.Spektra}
              about={[
                {
                  key: 3,
                  paragraph: `Christo Viljoen started giving financial advice as an agent with Fedsure Life in 1996.  He realised however that in order to give the best advice for the benefit of every client, he has to become an independent advisor with no restrictions placed on his advice by insurance companies or banks.  Spektra Financial Services was registered in 1998 and together with Prisma Accountants started giving unbiased advice to their clients.`,
                },
                {
                  key: 4,
                  paragraph:
                    "Registered as an Authorised Financial services Provider (FSP NO. 10679) with the Financial services Board, with the Council for Medica Schemes (ORG 240) and is covered by professional indemnity insurance to protect clients.",
                },
                {
                  key: 5,
                  paragraph:
                    "Christo Viljoen is registered with and subject to the professional code of conduct of The SAIFAA (South African Independent Financial Advisors Association), is licensed and has passes all written examinations as prescribed by the Financial services Board enabling him to provide financial advice. he is also registered with the Council for Medical Schemes (BR295) and has contracts with various large and Financial services Board approved Insurance and Asset Management Companies and has been offering financial advice and intermediary services since 1996.",
                },
              ]}
              list={{
                title: "Advice and intermediary services include:",
                items: [
                  {
                    key: 6,
                    name: "Investment advice and services",
                  },
                  {
                    key: 7,
                    name: "Long term insurance and services",
                  },
                  {
                    key: 8,
                    name: "Medical Fund advice and services",
                  },
                ],
              }}
              footer="Spektra Financial Services BK, 1998/067770/23, FSP 10679: An Authorised Financial Services Provider."
            />
          </section>
          <section style={{ paddingTop: "4rem" }} id="prisma" ref={prismaRef}>
            <AboutCard
              width={width}
              logo={PRISMA}
              title="Prisma"
              contactLink={Bookings.Prisma}
              about={[
                {
                  key: 9,
                  paragraph:
                    "Prisma Accountants is a professional accounting firm registered at the South African Institute of Professional Accountants situated in Magalieskruin in the Northern suburbs of Pretoria. Prisma Accountants act as a registered Tax Practitioner on behalf of the South African Revenue services (SARS). Prisma Accountants celebrated 22 years of existence in 2020 with great expectation and enthusiasm about our future. We work with our clients to help them grow and develop. Building long term relationships with our clients and providing them with personal service is one of our most important missions.",
                },
              ]}
              footer="The above is built on values of integrity and trust as well as being an integral part of our community, always giving back where possible. The above mission is strengthened because we are dedicated to developing and training new accountants, through traineeships as we are an Approved Training Centre at the South African Institute of Professional Accountants. The knowledge and capabilities of our employees lead to successful service delivery to you as a client."
            />
          </section>
        </Stack>
      </div>
      <Footer about />
    </section>
  );
});
